import './blur.css'
const Blur = () => {
    return (
        <div className='blur-container'>

        </div>
    )
}
export default Blur